import { Button, EmptyState } from '@bonanza-social/moonlight';
import animations from '../assets/animations';
import { useGoToPromos } from '../hooks';

export function PromosListEmpty() {
  return (
    <EmptyState
      titleNS="promos"
      titleKey="emptyListTitle"
      descriptionNS="promos"
      descriptionKey="emptyListDescription"
      animationSource={animations.promo}
      animationProps={{ sizeX: 150, sizeY: 150 }}
    />
  );
}

export function PromoDetailsEmpty() {
  return (
    <EmptyState
      titleNS="promos"
      titleKey="emptyDetailsTitle"
      descriptionNS="promos"
      descriptionKey="emptyDetailsDescription"
      animationSource={animations.promo}
      animationProps={{ sizeX: 150, sizeY: 150 }}
      marginHorizontal="space-400"
    >
      <Button
        variant="primary"
        onPress={useGoToPromos()}
        locNS="promos"
        locKey="goToPromotions"
        size="large"
      />
    </EmptyState>
  );
}
